import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

//importing components
//common components
import NotFound from './components/common/404'

//switch components
import AcsRedirectPage from './components/common/AcsRedirect'

//dna components
import DnaHostedPage from './components/dna'

// antar component
import AntarPage from './components/antar';

//EG components
import CCard from './components/earth-gateway/CheckoutForm'
import SavedCardInfo from './components/earth-gateway/SavedCardInfo'
import CVVInfo from './components/earth-gateway/SavedCardInfo/CVVInfo'
import EarthError from './components/earth-gateway/Error'
import CheckoutHosted from './components/checkout/Redirects'
import SavedCard from './components/checkout/SavedCard';
import PaystackHosted from './components/paystack/Redirects'
import AddCardPage from './components/add-card'
import MarsPaymentPage from './components/mars'
import SaturnSwitch from './components/saturn/saturn-switch'
import SaturnRedirect from './components/saturn/saturn-redirect'
import './App.css'
import './style.css'
import Redirect from './components/checkout/Redirects/redirect'
import PollStatus from './components/earth-gateway/CheckoutPollingForm'
import SaleHostedForm from './components/earth-gateway/CsHostedForm/sale';
import CsHostedFailure from './components/earth-gateway/CsHostedForm/hosted-failure';
import { initiateOpenReplay } from './components/mars/helper-functions';
import queryString from 'query-string';
import { getDecodedData } from './helpers';

function App() {
  const hasRunRef = useRef(false);
  useEffect(() => {
    // Use safe property access instead of optional chaining for Android 8 compatibility
    if (hasRunRef && hasRunRef.current) return;
    hasRunRef.current = true;
    const init = async () => {
      try {
        const url = window.location.href;
        const params = queryString.parseUrl(url);
        const { response } = params.query;
        if (response) {
          const { decodedString } = await getDecodedData(response);
          // Use safe property access instead of optional chaining
          var orderId = (decodedString && decodedString.order_id) ? decodedString.order_id : null;
          if (orderId) {
            initiateOpenReplay(orderId);
          }

          var faviconLink = document.getElementById('dynamic-favicon');
          if (decodedString && decodedString.show_reseller_branding) {
            if (decodedString.brand_name) {
              document.title = decodedString.brand_name;
            }
            if (decodedString.logo_url) {
              if (faviconLink) {
                faviconLink.href = decodedString.logo_url;
              }
            }
          } else {
            document.title = 'Datman';
          }

        }
      } catch (error) {
        console.error('Initialization failed', error);
      }
    };
    init();
  }, []);
  return (
    <Router>
      <Routes>
        {/* Earth and Pluto routes */}
        <Route path="/earth" element={<SavedCardInfo />} />
        <Route path="/pluto" element={<SavedCardInfo />} />
        <Route path="/earth/card" element={<CCard />} />
        <Route path="/pluto/card" element={<CCard />} />
        <Route path="/earth/pay" element={<CVVInfo />} />
        <Route path="/pluto/pay" element={<CVVInfo />} />
        <Route path="/earth/error/:data/:base64Data?" element={<EarthError />} />
        <Route path="/pluto/error/:data/:base64Data?" element={<EarthError />} />
        <Route path="/earth/AcsRedirect" element={<AcsRedirectPage />} />
        <Route path="/earth/polling" element={<PollStatus />} />

        {/* Checkout routes */}
        <Route path="/checkout/pay" element={<CheckoutHosted />} />
        <Route path="/checkout/save-card" element={<SavedCard />} />
        <Route path="/checkout/redirect" element={<Redirect />} />
        <Route path="/checkout/error/:data/:base64Data?" element={<EarthError />} />

        {/* Other routes */}
        <Route path="/add-card" element={<AddCardPage />} />
        <Route path="/paystack/pay" element={<PaystackHosted />} />
        <Route path="/dna" element={<DnaHostedPage />} />
        <Route path="/antar" element={<AntarPage />} />
        <Route path="/mars" element={<MarsPaymentPage />} />
        <Route path="/saturn-v2/switch" element={<SaturnSwitch />} />
        <Route path="/saturn/redirect" element={<SaturnRedirect />} />

        <Route path="/sale" element={<SaleHostedForm />} />
        <Route path="/failure" element={<CsHostedFailure />} />

        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;